import { render, staticRenderFns } from "./BuKa.vue?vue&type=template&id=8923266c&scoped=true&"
import script from "./BuKa.vue?vue&type=script&lang=js&"
export * from "./BuKa.vue?vue&type=script&lang=js&"
import style0 from "./BuKa.vue?vue&type=style&index=0&id=8923266c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8923266c",
  null
  
)

export default component.exports